import React from 'react';

import { LayoutRenderer } from './types';
import { buildTilePlaceholder } from './utils';

const SECONDARY_SLOTS = 6;

export const WideGridLayout: LayoutRenderer = ({ children, placeholder }) => {
  const nodes = React.Children.toArray(children).filter(Boolean);
  const [hero, ...rest] = nodes;
  const secondaryTiles = rest.slice(0, SECONDARY_SLOTS);

  const filledSecondary =
    secondaryTiles.length >= SECONDARY_SLOTS
      ? secondaryTiles
      : [
          ...secondaryTiles,
          ...Array.from({ length: SECONDARY_SLOTS - secondaryTiles.length }, (_, index) =>
            buildTilePlaceholder(placeholder, `wide-grid-secondary-${index}`)
          ),
        ];

  const primaryTile = hero ?? buildTilePlaceholder(placeholder, 'wide-grid-primary', 'hero');

  return (
    <div className="itv-row-collection__wide-grid">
      <div className="itv-row-collection__wide-grid-primary">{primaryTile}</div>
      <div className="itv-row-collection__wide-grid-secondary">
        {filledSecondary.map((tile, index) => (
          <div key={`wide-grid-secondary-cell-${index}`} className="itv-row-collection__wide-grid-cell">
            {tile}
          </div>
        ))}
      </div>
    </div>
  );
};
